import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/Calculate.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useCalculatePayableBillMutation, useGetPayableBillQuery, useGetTempEmployeesDropdownQuery } from "../../slices/admin/admin";
import { toast } from "react-toastify";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";
import Select from "react-select";

const Calculate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const billId = location.state?.id;
  const [calculateBill, { isLoading: isSaving }] = useCalculatePayableBillMutation();

  const { data, error, isLoading } = useGetPayableBillQuery(billId, {
    skip: !billId,
  });

  const billData = data?.data?.[0];
  const apiItems = billData?.items || [];

  const mode = location.state?.mode || "update";
  const isView = mode === "view";

  const [loadHandlerId, setLoadHandlerId] = useState("");

  const { data: loadHandlerData } = useGetTempEmployeesDropdownQuery({ empDesignation: 'loadHandler' });
  const loadHandlerList = loadHandlerData?.result || [];

  // Pre-fill if bill already has a loadHandler
  useEffect(() => {
    if (billData) {
      setLoadHandlerId(billData.loadHandlerId?._id || billData.loadHandlerId || "");
    }
  }, [billData]);

  const customerName = billData?.customerId?.firstName || "";
  const customerPhone = billData?.customerId?.phone || "";

  const [items, setItems] = useState([]);

  console.log(items, "items45555");

  useEffect(() => {
    if (apiItems.length > 0) {
      const mapped = apiItems.map((it) => ({
        _id: it._id,
        item: it.itemId?.productName || it.productName,
        category: it.itemId?.productBag || "-",
        buyingPrice: it.itemId?.buyingPrice || 0,
        sellingPrice: it.itemId?.sellingPrice || 0,
        overallPrice: it.itemId?.overallPrice || 0,
        override: it.itemId?.overrideOption || false,
        enteredPrice: it.price ?? "",
        // quantity: it.itemId?.overallQuantity || it.productCount || 0,
        quantity: it.itemId?.actualQuantity || it.productCount || 0,
        totalPrice: it.totalPrice ?? 0,

        minSellingPrice: it.itemId?.minSellingPrice ?? "-",
        soldPercentage: it.itemId?.soldPercentage ?? "-"
      }));
      setItems(mapped);
    }
  }, [apiItems]);



  const [commissionType, setCommissionType] = useState("price");
  const [commissionValue, setCommissionValue] = useState("");
  const [handleCharge, setHandleCharge] = useState("");
  const [logisticCharge, setLogisticCharge] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  // useEffect(() => {
  //   if (billData) {
  //     setPaymentMethod(billData.paymentMethod || "");
  //     setCommissionType(billData.saleCommission || "price");
  //     setCommissionValue(
  //       billData.saleCommission === "percentage" ? billData.percentage || "" : ""
  //     );
  //     setHandleCharge(billData.handleCharge || "");
  //     setLogisticCharge(billData.logisticCharge || "");

  //     if (billData.commissionAmount) {
  //       setCommissionValue(billData.percentage || "");
  //     }
  //   }
  // }, [billData]);

  useEffect(() => {
    if (billData) {
      setPaymentMethod(billData.paymentMethod || "");

      const firstItem = billData.items?.[0];
      const saleCommission = firstItem?.itemId?.inventoryId?.saleCommission || "price";

      setCommissionType(saleCommission);

      setCommissionValue(
        billData.saleCommission === "percentage" ? billData.percentage || "" : ""
      );

      setHandleCharge(billData.handleCharge || "");
      setLogisticCharge(billData.logisticCharge || "");

      if (billData.commissionAmount) {
        setCommissionValue(billData.percentage || "");
      }
    }
  }, [billData]);



  const calculateItemTotal = (i) => {
    if (i.override) {
      return i.overallPrice * i.quantity;
    }
    const basePrice = i.enteredPrice ? Number(i.enteredPrice) : i.buyingPrice;
    return basePrice * i.quantity;
  };


  const itemTotal = items.reduce((sum, i) => sum + calculateItemTotal(i), 0);


  const commissionAmount =
    commissionType === "percentage"
      ? (itemTotal * Number(commissionValue || 0)) / 100
      : Number(billData?.commissionAmount || 0);





  const overallTotal =
    itemTotal -
    Number(handleCharge || 0) -
    (billData?.logisticAmountPaidBy === "store" ? Number(logisticCharge || 0) : 0) -
    commissionAmount;

  const handleSaveConfirm = async () => {
    try {
      const payload = {
        handleCharge: Number(handleCharge || 0),
        logisticCharge: billData?.logisticAmountPaidBy === "store" ? Number(logisticCharge || 0) : 0,
        paymentMethod,
        saleCommission: commissionType,
        percentage: commissionType === "percentage" ? Number(commissionValue || 0) : 0,
        loadHandlerId,
        billingItems: items.map((i) => {
          const price = i.override
            ? i.overallPrice
            : i.enteredPrice
              ? Number(i.enteredPrice)
              : i.buyingPrice;

          return {
            billingItemId: i._id,
            //  overallQuantity: Number(i.quantity),
            actualQuantity: Number(i.quantity),
            price,
          };
        }),
      };

      const res = await calculateBill({ billId, payload }).unwrap();
      toast.success("Bill calculated successfully");
      // navigate("/dashboard/billing");
      navigate("/dashboard/billing", { state: { activeTab: location.state?.activeTab } });
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.data?.message || "Something went wrong ❌");
    }
  };



  return (
    <div className={styles.calculateContainer}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.tittle}>
          {isView ? "View Billing" : "Calculate Billing"}
        </h2>

        {/* <span onClick={() => navigate("/dashboard/billing")} className={styles.closeIcon}>
          ✕
        </span> */}
        <span
          onClick={() =>
            navigate("/dashboard/billing", {
              state: { activeTab: location.state?.activeTab },
            })
          }
          className={styles.closeIcon}
        >
          ✕
        </span>
      </div>
      <div className={styles.padding}>
        {/* Customer Info */}
        {/* <div className={styles.formSection}>
          <div className={styles.inputRow}>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Customer Name</label>
              <input className={styles.input} type="text" value={customerName} disabled={isView} />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Phone Number</label>
              <input className={styles.input} type="text" value={customerPhone} disabled={isView} />
            </div>
        
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Payment Type</label>
              <select
                className={styles.inputs}
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                disabled={isView}
              >
                <option value="">Select Payment Type</option>
                <option value="cash">Cash</option>
                <option value="upi">UPI</option>
                <option value="credit">Credit</option>
              </select>
            </div>

          </div>
        </div> */}
        {isView ? (
          // 👇 Show this in VIEW mode
          <div className={styles.ownerBox}>
            <p>
              <strong>Item Owner :</strong> {customerName}
            </p>
            <p>
              <strong>Phone No :</strong> {customerPhone}
            </p>
            <p>
              <strong>Payment Type :</strong> {paymentMethod}
            </p>
            {billData?.loadHandlerId && (
              <p>
                <strong>Load Handler :</strong> {billData.loadHandlerId.name || billData.loadHandlerId}
              </p>
            )}
          </div>
        ) : (
          // 👇 Show this in EDIT/CALCULATE mode
          <div className={styles.formSection}>
            <div className={styles.inputRow}>
              <div className={styles.ownerBoxs}>
                <p>
                  <strong>Item Owner :</strong> {customerName}
                </p>
                <p>
                  <strong>Phone No :</strong> {customerPhone}
                </p>
                {loadHandlerId && (
                  <p>
                    <strong>Load Handler :</strong> {loadHandlerList.find(e => e._id === loadHandlerId)?.name || "Selected"}
                  </p>
                )}
              </div>
              {/* <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Payment Type</label>
                <select
                  className={styles.inputs}
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  disabled={isView}
                >
                  <option value="">Select Payment Type</option>
                  <option value="cash">Cash</option>
                  <option value="upi">UPI</option>
                  <option value="credit">Credit</option>
                  <option value="bank">Bank</option>
                </select>
              </div> */}
            </div>
          </div>
        )}


        {/* Items Table */}
        {/* <div className={styles.itemsSection}>
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Category</th>
                  <th>Buying Price</th>
                  <th>Selling Price</th>
                  <th>Override Price</th>
                  <th>Given Price</th>
                  <th>Qty</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i, index) => (
                  <tr key={i._id}>
                    <td>{i.item}</td>
                    <td>{i.category}</td>
                    <td>₹{i.buyingPrice}</td>
                    <td>₹{i.sellingPrice}</td>
                    <td>{i.override ? "Yes" : "No"}</td>
                    <td>
                      {i.override ? (
                        <span>₹{i.overallPrice}</span>
                      ) : (
                        <input
                          type="number"
                          value={i.enteredPrice !== "" && i.enteredPrice !== null ? i.enteredPrice : i.buyingPrice}
                          onChange={(e) => {
                            let value = e.target.value;

                            const newItems = [...items];
                            newItems[index].enteredPrice = value;
                            newItems[index].totalPrice = value ? Number(value) * Number(i.quantity) : 0;
                            setItems(newItems);
                          }}
                          onBlur={() => {
                            let numValue = Number(i.enteredPrice);

                            if (!i.enteredPrice) {
                              numValue = i.buyingPrice; // fallback to buyingPrice instead of 0
                            }

                            if (i.buyingPrice > 0 && i.sellingPrice > 0 && numValue > 0) {
                              if (numValue < i.buyingPrice) {
                                toast.error(`Price cannot be less than Buying Price (₹${i.buyingPrice})`);
                                numValue = i.buyingPrice;
                              }
                              if (numValue > i.sellingPrice) {
                                toast.error(`Price cannot be more than Selling Price (₹${i.sellingPrice})`);
                                numValue = i.sellingPrice;
                              }
                            }

                            const newItems = [...items];
                            newItems[index].enteredPrice = numValue;
                            newItems[index].totalPrice = numValue * Number(i.quantity);
                            setItems(newItems);
                          }}
                          disabled={isView}
                        />
                      )}
                    </td>

                    <td>{i.quantity}</td>
                    <td>₹{i.totalPrice || calculateItemTotal(i)}</td>
                  </tr>
                ))}
                {items.length === 0 && (
                  <tr>
                    <td colSpan={8} className={styles.noData}>
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div> */}

        <div className={styles.itemsSection}>
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Category</th>
                  <th>Buying Price</th>
                  <th>Selling Price</th>
                  <th>Min Sold Price</th> {/* ✅ Added */}
                  <th>Sold %</th> {/* ✅ Added */}
                  <th>Override Price</th>
                  <th>Given Price</th>
                  <th>Qty</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i, index) => (
                  <tr key={i._id}>
                    <td>{i.item}</td>
                    <td>{i.category}</td>
                    <td>₹{i.buyingPrice}</td>
                    <td>₹{i.sellingPrice}</td>

                    {/* ✅ New Columns */}
                    <td>{i.minSellingPrice !== "-" ? `₹${i.minSellingPrice}` : "-"}</td>
                    <td>{i.soldPercentage !== "-" ? `${i.soldPercentage}%` : "-"}</td>


                    <td>{i.override ? "Yes" : "No"}</td>
                    {/* <td>
                      {i.override ? (
                        <span>₹{i.overallPrice}</span>
                      ) : (
                        <input
                          type="number"
                          value={
                            i.enteredPrice !== "" && i.enteredPrice !== null
                              ? i.enteredPrice
                              : i.buyingPrice
                          }
                          onChange={(e) => {
                            let value = e.target.value;
                            const newItems = [...items];
                            newItems[index].enteredPrice = value;
                            newItems[index].totalPrice = value
                              ? Number(value) * Number(i.quantity)
                              : 0;
                            setItems(newItems);
                          }}
                          onBlur={() => {
                            let numValue = Number(i.enteredPrice);

                            if (!i.enteredPrice) {
                              numValue = i.buyingPrice;
                            }

                            if (i.buyingPrice > 0 && i.sellingPrice > 0 && numValue > 0) {
                              if (numValue < i.buyingPrice) {
                                toast.error(
                                  `Price cannot be less than Buying Price (₹${i.buyingPrice})`
                                );
                                numValue = i.buyingPrice;
                              }
                              if (numValue > i.sellingPrice) {
                                toast.error(
                                  `Price cannot be more than Selling Price (₹${i.sellingPrice})`
                                );
                                numValue = i.sellingPrice;
                              }
                            }

                            const newItems = [...items];
                            newItems[index].enteredPrice = numValue;
                            newItems[index].totalPrice =
                              numValue * Number(i.quantity);
                            setItems(newItems);
                          }}
                          disabled={isView}
                        />
                      )}
                    </td> */}

                    <td>
                      <td>
                        <input
                          type="number"
                          value={
                            i.enteredPrice !== "" && i.enteredPrice !== null
                              ? i.enteredPrice
                              : i.override
                                ? i.overallPrice
                                : i.buyingPrice
                          }
                          onChange={(e) => {
                            let value = e.target.value;
                            const newItems = [...items];
                            newItems[index].enteredPrice = value;
                            newItems[index].totalPrice =
                              value ? Number(value) * Number(i.quantity) : 0;
                            setItems(newItems);
                          }}
                          onBlur={() => {
                            let numValue = Number(i.enteredPrice);

                            if (!i.enteredPrice) {
                              numValue = i.override ? i.overallPrice : i.buyingPrice;
                            }

                            if (i.buyingPrice > 0 && i.sellingPrice > 0 && numValue > 0) {
                              if (numValue < i.buyingPrice) {
                                toast.error(
                                  `Price cannot be less than Buying Price (₹${i.buyingPrice})`
                                );
                                numValue = i.buyingPrice;
                              }
                              if (numValue > i.sellingPrice) {
                                toast.error(
                                  `Price cannot be more than Selling Price (₹${i.sellingPrice})`
                                );
                                numValue = i.sellingPrice;
                              }
                            }

                            const newItems = [...items];
                            newItems[index].enteredPrice = numValue;
                            newItems[index].totalPrice =
                              numValue * Number(i.quantity);
                            setItems(newItems);
                          }}
                          disabled={isView}
                        />
                      </td>

                    </td>

                    <td>{i.quantity}</td>
                    <td>₹{i.totalPrice || calculateItemTotal(i)}</td>
                  </tr>
                ))}

                {items.length === 0 && (
                  <tr>
                    <td colSpan={10} className={styles.noData}>
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>


        {/* Charges Section */}
        <div className={styles.chargesSection}>
          <div className={styles.inputRows}>
            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Commission Type : </label>
              {/* <input className={styles.inputones} type="text" value={commissionType} readOnly /> */}
              <h2 className={styles.inputones}>{commissionType}</h2>
            </div>
            {commissionType === "percentage" && (
              <div className={styles.inputGroups}>
                <label className={styles.inputLabel}>Commission Amount : </label>
                <h2 className={styles.inputones}>₹ {commissionAmount}</h2>

              </div>
            )}
            {commissionType === "percentage" && (
              <div className={styles.inputGroupss}>
                <label className={styles.inputLabel}>Enter % : </label>
                <input
                  // className={styles.inputone}
                  className={`${styles.inputone} ${isView ? styles.inputoneview : styles.inputone
                    }`}
                  type="number"
                  placeholder="Enter  Percentage %"
                  value={commissionValue}
                  onChange={(e) => setCommissionValue(e.target.value)}
                  disabled={isView}
                />
              </div>
            )}

            {/* {billData?.logisticAmountPaidBy !== "farmer" && ( */}
            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Transport Person Charge : </label>
              <h2 className={styles.inputones}>₹ {logisticCharge}</h2>
            </div>
            {/* )} */}



            <div className={styles.inputGroups}>
              <Select
                isDisabled={isView}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: "1px solid #6D6D6D",
                    borderRadius: "6px",
                    fontSize: "16px",
                    minHeight: "50px",
                    boxShadow: "none",
                    color: "black",
                    fontWeight: "600",
                    width: "410px",
                    marginBottom: "15px"
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#6D6D6D",
                    fontSize: "16px",
                    fontWeight: "600",
                  }),
                }}
                value={
                  loadHandlerList.find(e => e._id === loadHandlerId)
                    ? { value: loadHandlerId, label: `${loadHandlerList.find(e => e._id === loadHandlerId)?.name}` }
                    : billData?.loadHandlerId
                      ? { 
                          value: billData.loadHandlerId._id || billData.loadHandlerId, 
                          label: billData.loadHandlerId.name || "Selected Handler" 
                        }
                      : null
                }
                onChange={(opt) => setLoadHandlerId(opt ? opt.value : "")}
                options={loadHandlerList.map(e => ({ value: e._id, label: `${e.name} - ${e.phone}` }))}
                placeholder="Select Load Handler"
                isSearchable
                isClearable
              />
            </div>


            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Handler Charge : </label>
              <input
                // className={styles.inputone}
                className={`${styles.inputone} ${isView ? styles.inputoneview : styles.inputone
                  }`}
                type="number"
                value={handleCharge}
                onChange={(e) => setHandleCharge(e.target.value)}
                disabled={isView}
              />
            </div>
          </div>

          <div className={styles.inputRows}>

            {/* {billData?.logisticAmountPaidBy !== "farmer" && (
              <div className={styles.inputGroups}>
                <label className={styles.inputLabel}>TransportCharge : </label>
                <h2 className={styles.inputones}>₹ {logisticCharge}</h2>
              </div>
            )} */}
            <div className={styles.inputGroups}></div>
            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Overall Total : </label>
              <h2 className={styles.inputones}>₹ {overallTotal}</h2>
            </div>
            <div></div>
            <div className={`${styles.inputGroups} ${styles.paymentTypeGroup}`}>
              <label className={styles.inputLabel}>Payment Type</label>
              <select
                className={styles.inputs}
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                disabled={isView}
              >
                <option value="">Select Payment Type</option>
                <option value="cash">Cash</option>
                <option value="upi">UPI</option>
                <option value="credit">Credit</option>
                <option value="bank">Bank</option>
              </select>
            </div>
          </div>




        </div>

        {/* Footer */}
        <div className={styles.footerButtons}>
          {/* <button className={styles.cancelBtn} onClick={() => navigate("/dashboard/billing")}>
            Cancel
          </button> */}
          <button
            className={styles.cancelBtn}
            onClick={() =>
              navigate("/dashboard/billing", {
                state: { activeTab: location.state?.activeTab },
              })
            }
          >
            Cancel
          </button>
          {!isView && (
            <button
              className={styles.saveBtn}
              onClick={() => setConfirmModalOpen(true)}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Pay"}
            </button>
          )}
        </div>

        <DeleteConfirmModalLogout
          isOpen={confirmModalOpen}
          onConfirm={handleSaveConfirm}
          onCancel={() => setConfirmModalOpen(false)}
          title="Are you sure?"
          heading="Confirm Calculation"
          content="Once verified, you will not be able to access Calculate again. Do you want to continue?"
        />

      </div>
    </div>
  );
};

export default Calculate;



